import { isScreenLessThan, SCREEN_SIZE } from '@jooxter/utils';
import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash-es';

export const getScreenSizeBreakpoint = (width: number): number => {
  return Object.values(SCREEN_SIZE)
    .filter((value) => typeof value === 'number')
    .reduce((acc, value) => {
      return width >= value && value > acc ? value : acc;
    }, 0);
};

const useIsSmallScreen = (smallScreenDef = SCREEN_SIZE.LG): boolean => {
  const [currentScreen, setCurrentScreen] = useState<number>(getScreenSizeBreakpoint(window.innerWidth));
  const isSmallScreen = useMemo(() => isScreenLessThan(currentScreen, smallScreenDef), [smallScreenDef, currentScreen]);

  useEffect(() => {
    const handleWindowResize = () => {
      const newBreakpoint = getScreenSizeBreakpoint(window.innerWidth);
      // Only update state if the breakpoint actually changed
      if (newBreakpoint !== currentScreen) {
        setCurrentScreen(newBreakpoint);
      }
    };

    const debouncedHandleResize = debounce(handleWindowResize, 50);
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
      debouncedHandleResize.cancel();
    };
  }, [currentScreen]);

  return isSmallScreen;
};

export default useIsSmallScreen;
